<template>
    <el-checkbox-group v-model="data">
        <el-checkbox v-for="(item, index) in list" :label="valueSolt ? item[value]+ item[valueSolt] : item[value]" :disabled="item['disabled']" :key="index" @change="changeBox($event, item[value], item)">{{item[label]}}</el-checkbox>
    </el-checkbox-group>
</template>

<script>
export default {
  name: 'MyCheckboxGroup',
  model: {
    prop: 'checkbox', // 要存在于proops
    event: 'change' // 当组件的值发生改变时要emit的事件名
  },
  props: {
    checkbox: { // 默认值
      type: Array,
      default: () => {
        return [];
      }
    },
    label: {
      type: String,
      default: 'label'
    },
    value: {
      type: String,
      default: 'value'
    },
    valueSolt: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }, 
  },
  data() {
    return {
      data: this.checkbox
    };
  },
  methods: {
    changeBox(flag, val, item) {
      this.$emit('changeBox', flag, val, item);
    },
    // handleCheckChange(val){
    //     this.$emit('handleCheckChange',val);
    // }
  },

  watch: { // 这里检测data中的值，一旦发生变化就提交事件到父组件
    data: {
      handler(newVal) {
        this.$emit('change', newVal);
      },
      deep: true
    },
    checkbox:{
      handler(newval){
        this.data=newval;
      }
    }
  },
};
</script>